module.exports = __webpack_public_path__ + "97be3c364b68ec9302b331e07dc1cee7.svg";